"use client";

import { Button } from "@relume_io/relume-ui";
import React, { useState, useEffect } from "react";
import { RxChevronRight } from "react-icons/rx";
import { HERO_IMAGES } from "../../constants/images";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaYoutube, FaPlay } from "react-icons/fa";

const phrases = [
  {
    top: "Unleash Your Story",
    bottom: "Across Every Medium",
  },
  {
    top: "From Idea to Universe",
    bottom: "One Source of Truth",
  },
  {
    top: "Write Once, Build Forever",
    bottom: "Consistency Across All Formats",
  },
  {
    top: "Your Story DNA",
    bottom: "Infinite Media Expressions",
  },
  {
    top: "Where Universes Are Born",
    bottom: "And Stories Never End",
  },
];
// TODO: Add a demo video to the hero section
export function Layout1() {
  const [selectedImageIndex] = useState(() => 
    Math.floor(Math.random() * HERO_IMAGES.length)
  );
  const navigate = useNavigate();
  const [showDemoBanner, setShowDemoBanner] = useState(true);

  // Phrase rotation logic
  const [phraseIndex, setPhraseIndex] = useState(() =>
    Math.floor(Math.random() * phrases.length)
  );
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out
      setTimeout(() => {
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
        setFade(true); // Fade in new phrase
      }, 500); // Duration of fade out
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  const handleNavigate = () => {
    navigate('/product');
  };

  return (
    <section className="relative min-h-[90vh] w-full overflow-hidden">
      {/* Hero Images */}
      <div className="absolute inset-0 z-0">
        {/* Single Random Image */}
        <div className="relative h-full w-full">
          <div className="absolute inset-0">
            <img
              src={HERO_IMAGES[selectedImageIndex]}
              className="h-full w-full object-cover"
              alt="Transforming stories across formats"
            />
          </div>
        </div>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 to-gray-900/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex min-h-[90vh] items-center">
        <div className="mx-auto max-w-7xl px-4 pt-12 pb-20 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="mb-8 text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl relative h-[4.5em] flex flex-col items-center justify-center">
              <div className="relative w-full">
                <AnimatePresence mode="wait">
                  <motion.span
                    key={phraseIndex + "-top"}
                    initial={{ opacity: 0, scale: 0.95, filter: "blur(8px)" }}
                    animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                    exit={{ opacity: 0, scale: 1.05, filter: "blur(12px)" }}
                    transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
                    className="block w-full"
                  >
                    {phrases[phraseIndex].top}
                  </motion.span>
                </AnimatePresence>
              </div>
              <div className="relative w-full">
                <AnimatePresence mode="wait">
                  <motion.span
                    key={phraseIndex + "-bottom"}
                    initial={{ opacity: 0, scale: 0.95, filter: "blur(8px)" }}
                    animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                    exit={{ opacity: 0, scale: 1.05, filter: "blur(12px)" }}
                    transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
                    className="block text-primary-400 w-full"
                  >
                    {phrases[phraseIndex].bottom}
                  </motion.span>
                </AnimatePresence>
              </div>
            </h1>
            <p className="mx-auto mt-8 mb-12 max-w-2xl text-xl text-gray-300">
                Omnigeist is a <b>Transmedia IP Development Platform</b> built around a <b>Context Management System</b> , 
                so your universe stays consistent across every novel, game, script, or VR experience you create.
            </p>
            <div className="mt-10 flex items-center justify-center gap-6">
              <Button 
                title="Explore" 
                variant="secondary"
                className="px-8 py-4 text-lg"
                onClick={handleNavigate}
              >
                Explore
              </Button>
              <Button
                title="Learn More"
                variant="link"
                size="link"
                iconRight={<RxChevronRight />}
                className="text-lg text-white hover:text-primary-400"
                onClick={handleNavigate}
              >
                Learn More
              </Button>
              <motion.a
                href="https://youtu.be/0vMXJWAk9pw"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-4 text-lg font-medium text-white hover:text-primary-400 transition-colors"
                whileHover={{ scale: 1.05 }}
              >
                <FaYoutube className="w-6 h-6 text-red-500" />
                See it in Action
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}